import $ from 'jquery';
import constants from 'Constants.js';
import { View } from 'backbone';
import listService      from 'ListService.js';
import eventBus from 'EventBus.js';
import util from 'util/Util.js';
import BaseTableView from 'properties/BaseTableView.js'
import Template from 'behaviors/properties/main/checkMandatorySettings.ejs';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
//=====================================================================
//
// An instance of this view represents a Check Mandatory.
//
// Casey Justus, May 2, 2016
//
//=====================================================================

class CheckMandatorySettings extends BaseTableView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.minRows = 5;

        this.events = {
            'change input[type=checkbox]'   : 'updateCheckAttributes',
            'change textarea'               : 'updateAttributes',
            'blur textarea'                 : 'lostFocus',
            'focus textarea'                : 'getFocus',
            'change input[type=radio]'      : 'updateAttributes',
            "click .itemNew"                : "itemNew",
            "click .itemRemove"             : "itemRemove"
        };

        let grid = [];
        if (this.model.get('Property')) {
            const prop = this.model.get('Property');
            // check if Array or not
            // load each one into the GridData (addItem)
            if (prop.Item) {
                if (Array.isArray(prop.Item)) {
                        _.forEach(prop.Item, (item) => {

                            let objName = item._value.indexOf("$") > -1 ? item._value.replace('$v','') : item._value;
                            let obj = listService.getObject(listService.cleanId(objName));
                            if (!obj) {
                                obj = listService.getPage(listService.cleanId(objName));
                            }
                            if(!util.isEmpty(obj)) {
                                grid.push({name: obj ? obj.model.get('name') : ''});
                            }
                        });
                } else {
                    let objName = prop.Item._value.indexOf("$") > -1 ? prop.Item._value.replace('$v','') : prop.Item._value;
                    let obj = listService.getObject(listService.cleanId(objName));
                    if (!obj){ //Then it is a page and not a control
                        obj = listService.getPage(listService.cleanId(objName));
                    }
                    if(!util.isEmpty(obj)) {
                        grid.push({name: obj ? obj.model.get('name') : '', id: obj ? obj.model.get('id') : ''});
                    }
                }
            }
        }
        this.model.set('gridData', grid,{silent:true});

        // should have 3 empty rows onyl if gridData doensn't exist or it has less of three elements
        const gridData = this.model.get('gridData');
        if(!gridData || gridData.length < this.minRows || this.isGridDataEmpty(gridData)){
            for (let i = grid.length; i < this.minRows ; ++i) {
                grid.push({name: ''});
            }
            this.model.set('gridData', grid,{silent:true});
        }

        this.updateObjectCount();
        this.enableDefaultMessage();
        this.listenTo(this.model, 'change', this.render);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    }

    //Method used when the behavior is loaded for first time to see if the griddata is totally empty
    isGridDataEmpty(gridData){
       return gridData.filter( r => r.name !== '' ).length === 0;
    }

    itemNew(){
        util.saveGridScrollPos(this.model);
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);

        this.model.set('multipleSelectionEnabled', true, { silent: true });
        //variable used to display the table's rows in a specialw way (only the name of the columns) according with flash
        this.model.set('avoidRows', true, { silent: true });

        var sfModal = new selectFieldModalView({model: this.model, mode: 'objectsANDlists'});
        let _self = this;
        sfModal.render().then((selectedFields) => {
            let gridData = this.model.get('gridData');
            $(selectedFields).each(function (idx, selectedField) {
                let alreadyAdded = false;
                let items;
                if (typeof _self.model.get('Property').Item !== 'undefined') {
                    if ($.isArray(_self.model.get('Property').Item)) {
                        items = _self.model.get('Property').Item;
                    } else {
                        items = [ _self.model.get('Property').Item ];
                    }
                }
                if (items) {
                    items.map((item, index) => {
                        if (item._value === selectedField.id) {
                            alreadyAdded = true;
                        }
                    });
                }
                if (!alreadyAdded) {
                    _self.addItem(selectedField);
                    let property = _self.model.get('Property');
                    if (!property.Item) {
                        property.Item = [];
                    }else if (!$.isArray(property.Item)){
                        property.Item = [ _.clone(property.Item) ];
                    }

                    property.Item.push({ _value: selectedField.id });
                    _self.model.set('Property', property, { silent: true });
                }
            });
        }).catch(err => console.log(err));
    }

    addItem(selectedField){
        var gridData = this.model.get('gridData');
        var addNew = true;
        gridData.map((item, index)=>{
            if(item.name === "" && addNew){
                gridData[index] = selectedField;
                addNew = false;
            }
        });

        if(addNew){
            gridData.push(selectedField);
        }

        this.model.set('gridData', gridData,{silent:true});

        this.updateObjectCount();
        this.model.trigger('change');
        this.render();
    }

    updateObjectCount(remove){
        if (this.model.get('autosummary')) {
            var gridData = this.model.get('gridData');
            let objCount = this.getObjectCount();
            this.model.set('widgetText', objCount + (parseInt(objCount) === 1 ?  ' object' : ' objects'), {silent:true});

            const rows = this.minRows - gridData.length;
            if(rows > 0 && remove){
                for (let i = 0; i < rows ; i++) {
                    gridData.push({name: ''});
                }
                this.model.set('gridData', gridData,{silent:true});
            }
            
        }
    }

    getObjectCount(){
        const
            gridData = this.model.get('gridData'),
            nonEmptyObjects = gridData.filter(function(data){ return data.name !== "" } );
        return nonEmptyObjects.length.toString();
    }

    itemRemove(){
        const rowid = this.model.get('rowid');
        if (typeof rowid !== 'undefined') {
            let gridData = this.model.get('gridData');
            let property = this.model.get('Property');

            if (typeof gridData[rowid].name !== 'undefined' && gridData[rowid].name !== '') {
                let item;
                if (Array.isArray(property)) {
                    item = property[0].Item;
                } else {
                    item = property.Item;
                }

                if (Array.isArray(item)) {
                    item.splice(rowid, 1);
                } else { //If it is only one element
                    item = [];
                }

                property.Item = item;
                this.model.set('Property', property, { silent: true });

                super.itemRemove();
                this.updateObjectCount(true);
                this.model.trigger('change');
            }
        }
    }

    updateAttributes(ev) {
        util.saveGridScrollPos(this.model);

        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set( propName, propVal,{silent:true} );
        this.enableDefaultMessage();
        this.model.trigger('change');
    }

    enableDefaultMessage() {
        if (this.model.get('defaultMessage') === 'true'){
            this.model.set({customMessageDisabled: 'disabled'},{silent:true});
        }else {
            this.model.set({customMessageDisabled: ''},{silent:true});
        }
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal,{silent:true} );
        this.model.trigger('change');
    }

    afterRender(){
        this.updateObjectCount();

        $("input:radio[value='"+this.model.get('defaultMessage')+"']").attr('checked', true);

        let bStopExecution = util.isTrue(this.model.get('stopExecution'));
        $(`input[name='stopExecution']`).prop('checked', bStopExecution );
        util.setGridScrollPos(this.model);
    }

}

export default CheckMandatorySettings;
